// src/pages/HomePage.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography, Box } from '@mui/material';

const HomePage = () => {
  return (
    <Box sx={{ textAlign: 'center', marginTop: 4 }}>
      <Typography variant="h4" gutterBottom>
        Welcome
      </Typography>
      {/* <Button variant="contained" color="primary" component={Link} to="/login">
        Login
      </Button> */}
    </Box>
  );
};

export default HomePage;